import { gql } from 'graphql-request'

export const GET_BOOKS_FROM_BANNER = gql`
  query GetBooksFromBanner(
    $highlightBannerId: Int!
    $displayType: DisplayType!
    $limitPerPage: Int
    $page: Int
    $bookType: BookType
    $categoryIds: [Int!]
    $penNameIds: [Int!]
    $searchText: String
  ) {
    getBooksFromBanner(
      highlightBannerId: $highlightBannerId
      displayType: $displayType
      limitPerPage: $limitPerPage
      page: $page
      bookType: $bookType
      categoryIds: $categoryIds
      penNameIds: $penNameIds
      searchText: $searchText
    ) {
      page
      total
      data {
        id
        writer
        penName {
          firstPenName
          user {
            id
            profilePageSlug
            writer {
              affiliation
              status
            }
            displayName
          }
        }
        tags {
          id
          name
        }
        category {
          id
          name
        }
        hasSalePromotions
        buyAllChaptersPromotion {
          startDate
          endDate
          discountType
          discountPercentage
        }
        readFreePromotion {
          startedAt
          endedAt
        }
        bookBadges {
          badgeCategoryId
          badgeImageUrl
        }
        bookChapterCampaignHeader {
          minSellingPrice
          totalChapter
          startedAt
          endedAt
        }
        coverImgPath
        coverResizeImgPath
        title
        cover
        isTranslated
        isEnded
        bookType
        isEbook
        likeCount
        viewCount
        commentCount
        isLiked
        publishedChapterCount
        newChapter {
          id
          chapterName
        }
        writingType
        publishedAt
        isEpub
        isPdf
      }
    }
  }
`
